export default __webpack_public_path__ + "static/media/ucla.c07446e6.jpg";